export default __webpack_public_path__ + "static/media/history.45fa36cd.svg";